/**
 * Match EnhancedPhotosTab: ordered photo type chips from flat formatted photos.
 * @param {Array<{ type: string, displayName?: string, configuration?: Array }>} photos
 * @returns {Array<[string, { count: number, type: string }]>}
 */
export function computeOrderedPhotoTypeEntries(photos) {
  if (!photos?.length) return [];

  const photoTypes = {};
  photos.forEach((photo) => {
    const label = photo.displayName || photo.type;
    if (!photoTypes[label]) {
      photoTypes[label] = { count: 1, type: photo.type };
    } else {
      photoTypes[label].count += 1;
    }
  });

  const configuration = photos[0]?.configuration;
  const entries = Object.entries(photoTypes);
  if (!configuration || !Array.isArray(configuration)) {
    return entries;
  }

  return entries.sort((a, b) => {
    const typeA = a[1].type;
    const typeB = b[1].type;
    const configA = configuration.find((c) => c.id === typeA);
    const configB = configuration.find((c) => c.id === typeB);
    return (configA?.index ?? 999) - (configB?.index ?? 999);
  });
}
